import { axiosClient } from '../api/axiosClient';
import { AxiosError } from 'axios';
import { trackException } from '../utils/monitoring';

export class CustomerSessionNotFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CustomerSessionNotFoundError';
  }
}

export interface CustomerSessionResponse {
  customer: string;
  client_secret: string;
}

const repackageAxiosError = (error: AxiosError, message: string): Error => {
  const errorData = error.response?.data as { message?: string } | undefined;
  const errorMessage = errorData?.message || error.message;
  trackException(new Error(`${message}: ${errorMessage}`));
  return new Error(`${message}: ${errorMessage}`);
};

export const getCustomerSession =
  async (): Promise<CustomerSessionResponse> => {
    try {
      const response = await axiosClient.post<CustomerSessionResponse>(
        '/subscriptions/customer-session'
      );
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;

      // Handle 404 specifically - customer session not found
      if (axiosError.response?.status === 404) {
        throw new CustomerSessionNotFoundError('Customer session not found');
      }

      throw repackageAxiosError(axiosError, 'Failed to fetch customer session');
    }
  };
